/**
 * Applications module theme — aliases app brand (Patient indigo SoT).
 *
 * Prefer importing from here in Applications UI so the module stays swappable
 * without reaching into Patients/. Color changes still flow from patientTheme.
 */
export {
  BRAND_THEME as APPLICATION_THEME,
  BRAND_THEME_HEX as APPLICATION_THEME_HEX,
} from "../../ui/brandTheme";

/** Form card icon tile — one brand tone for all templates. */
export const APPLICATION_FORM_ICON = {
  color: "bg-indigo-50",
  textColor: "text-indigo-700",
  hoverColor: "hover:bg-indigo-100",
};
